/* eslint-disable no-useless-escape */
import React, { useContext, FC } from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from '@material-ui/core'
import { CreateOutlined } from '@material-ui/icons'
import SignupLayout from '../../layout'
import LeftImageSection from '../../layout/leftImageSection'
import { SignupContext } from '../../context/SignupContextContainer'
import SIGNUP_STEPS from '../../utils/constants'
import newWindow from '../../utils/newWindow'

const Writer: FC = () => {
  const { setSignupStep } = useContext(SignupContext)
  const history = useHistory()

  const title = (): JSX.Element => {
    return (
      <div className="left-title">
        <p className="confirm-title">WE HELP YOU WORK SMARTER.</p>
      </div>
    )
  }

  const skipStep = (): void => {
    setSignupStep(SIGNUP_STEPS.WELCOME)
    history.push('/client/welcome')
  }

  return (
    <SignupLayout>
      <LeftImageSection title={title()} img="/assets/images/4.jpg" />
      <div className="signup-form writer">
        <p className="sub-title no-border">NOT A PROFESSIONAL WRITER?</p>
        <p className="description">
          No problem! Let our Wingman Template Assist draft perfect emails for you to send out to
          prospects. Simply, fill in the blanks, copy and paste, review for accuracy, then sit back
          and let your sales funnel fill up!
        </p>
        <div className="form">
          <div className="button-container">
            <Button size="large" variant="contained" color="primary" style={{ marginRight: 10 }}>
              <CreateOutlined style={{ marginRight: 10 }} />
              LAUNCH TEMPLATE ASSIST
            </Button>
            <Button
              size="large"
              variant="contained"
              color="primary"
              onClick={(): void => {
                newWindow('/settings/templates?fullscreen=true', 'Maverick Subscriptions')
              }}
            >
              I WRITE GREAT EMAILS.
            </Button>
          </div>
          <Button size="medium" color="primary" className="skipThis" onClick={skipStep}>
            Skip this step.
          </Button>
        </div>
      </div>
    </SignupLayout>
  )
}
export default Writer
